import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const features = ['Listos para copiar y pegar', 'Diseñados para profesionales reales', 'Ahorra horas de trabajo semanal', 'Crea contenido de mayor calidad', 'IA que suena natural y humana', 'Sin necesidad de conocimientos técnicos'];
export function WhyDifferent() {
  return <section className="py-24 md:py-32 relative" data-id="element-422">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-423">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-424">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-425">
            <h2 className="font-display text-4xl md:text-5xl text-cream mb-8" data-id="element-426">
              Por qué esto es diferente
            </h2>
            <p className="text-cream/60 text-lg font-light mb-10 leading-relaxed" data-id="element-427">
              No es otro PDF lleno de prompts genéricos como "escribe un post
              sobre marketing". Es un sistema estructurado con variables,
              contexto y comandos avanzados simplificados para ti.
            </p>

            <div className="space-y-4" data-id="element-428">
              {features.map((feat, idx) => <motion.div key={idx} initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: idx * 0.1
            }} className="flex items-center gap-4" data-id="element-429">
                  <div className="w-6 h-6 rounded-full bg-gold/10 border border-gold/30 flex items-center justify-center shrink-0" data-id="element-430">
                    <Check size={12} className="text-gold" data-id="element-431" />
                  </div>
                  <span className="text-cream/80 font-light" data-id="element-432">{feat}</span>
                </motion.div>)}
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="relative" data-id="element-433">
            <div className="aspect-square md:aspect-[4/3] rounded-sm border border-gold/20 bg-black-100/50 p-8 relative overflow-hidden flex flex-col justify-center" data-id="element-434">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-gold/50 to-transparent" data-id="element-435"></div>

              <div className="space-y-6 relative z-10" data-id="element-436">
                <div className="bg-black/50 border border-white/5 p-4 rounded-md" data-id="element-437">
                  <span className="text-red-400/80 text-xs uppercase tracking-widest mb-2 block" data-id="element-438">
                    El prompt promedio (Malo)
                  </span>
                  <p className="text-cream/50 font-mono text-sm" data-id="element-439">
                    "Escribe un post de Instagram sobre bienes raíces."
                  </p>
                </div>

                <div className="bg-gold/5 border border-gold/30 p-4 rounded-md shadow-[0_0_30px_rgba(212,175,122,0.1)]" data-id="element-440">
                  <span className="text-gold text-xs uppercase tracking-widest mb-2 block flex items-center gap-2" data-id="element-441">
                    <Check size={12} data-id="element-442" /> El prompt de La Biblia (Pro)
                  </span>
                  <p className="text-cream/90 font-mono text-sm leading-relaxed" data-id="element-443">
                    "Actúa como un Realtor top producer. Escribe un caption
                    educativo para Instagram dirigido a primeros compradores en
                    [Ciudad]. Usa el framework PAS (Problema, Agitación,
                    Solución). Tono: empático pero autoritario. Incluye un CTA
                    para agendar asesoría gratuita."
                  </p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}